import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	careers: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	events: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	blogs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	investorRelations: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	atlassianFoundation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pressKit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contactUs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'twg-microsite.footer.company.heading',
		defaultMessage: 'Company',
		description: 'Heading for the Company column in the footer',
	},
	careers: {
		id: 'twg-microsite.footer.company.careers',
		defaultMessage: 'Careers',
		description: 'Footer link in the Company column',
	},
	events: {
		id: 'twg-microsite.footer.company.events',
		defaultMessage: 'Events',
		description: 'Footer link in the Company column',
	},
	blogs: {
		id: 'twg-microsite.footer.company.blogs',
		defaultMessage: 'Blogs',
		description: 'Footer link in the Company column',
	},
	investorRelations: {
		id: 'twg-microsite.footer.company.investorRelations',
		defaultMessage: 'Investor Relations',
		description: 'Footer link in the Company column',
	},
	atlassianFoundation: {
		id: 'twg-microsite.footer.company.atlassianFoundation',
		defaultMessage: 'Atlassian Foundation',
		description: 'Footer link in the Company column',
	},
	pressKit: {
		id: 'twg-microsite.footer.company.pressKit',
		defaultMessage: 'Press kit',
		description: 'Footer link in the Company column',
	},
	contactUs: {
		id: 'twg-microsite.footer.company.contactUs',
		defaultMessage: 'Contact us',
		description: 'Footer link in the Company column',
	},
});
